import React from "react";
import type { PaymentMethod } from "@/types";

/**
 * Payment-method badges in each provider's brand colour with its name.
 * (Simple wordmark tiles; official logo files can replace them later.)
 */
const STYLE: Record<Exclude<PaymentMethod, "cash_on_pickup">, { bg: string; text: string }> = {
  payme: { bg: "#00b3c4", text: "payme" },
  click: { bg: "#0091ff", text: "click" },
  uzum: { bg: "#7000ff", text: "uzum" },
};

export function PayBadge({ method }: { method: PaymentMethod }) {
  if (method === "cash_on_pickup") {
    return (
      <span className="pay-badge pay-badge--cash" aria-hidden="true">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2.5" y="6" width="19" height="12" rx="2" />
          <circle cx="12" cy="12" r="2.6" />
          <path d="M6 9.5v5M18 9.5v5" />
        </svg>
      </span>
    );
  }
  const s = STYLE[method];
  return (
    <span className="pay-badge" style={{ background: s.bg }} aria-hidden="true">
      <span className="pay-badge__text">{s.text}</span>
    </span>
  );
}
